import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import err_list_ico_viewed from "../assets/error_list_viewed.svg";
import newErrIco from "../assets/new_err_ico.svg";
import newErrIcoDrk from "../assets/new_err_ico_drk.svg";
import eyeIco from "../assets/eye_ico.svg";
import eyeIcoDrk from "../assets/eye_ico_drk.svg";
import err_list_ico from "../assets/error_list_new.svg";
 
const ErrorComponent = ({new_count,view_count,data,handleOpen}) => {
    const [tab, setTab] = useState(0);
   return (
    <Grid container my={1} spacing={2} className="error">
    <Grid item sm={6} md={6} display={"flex"}>
      <Box
        component="button"
        width={"35%"}
        onClick={() => setTab(0)}
        sx={{ cursor: "pointer" }}
        justifyContent={"space-between"}
        className={`card ${tab === 0 && "tab_active"}`}
        borderRadius={"10px"}
        padding={"1% 3%"}
        alignItems={"center"}
        display={"flex"}
        marginRight={"10px"}
      >
        <img src={tab === 0 ? newErrIco : newErrIcoDrk} />
        <Typography fontSize={16} fontWeight={tab === 0 ? 500 : 400}>
          New Error
        </Typography>
        <Typography variant="body1" fontWeight={700} fontSize={20}>
          {new_count}
        </Typography>
      </Box>
      <Box
        component="button"
        width={"35%"}
        height={"65px"}
        onClick={() => setTab(1)}
        sx={{ cursor: "pointer" }}
        justifyContent={"space-between"}
        className={`card ${tab === 1 && "tab_active"}`}
        borderRadius={"10px"}
        padding={"1% 3%"}
        alignItems={"center"}
        display={"flex"}
      >
        <img src={tab === 1 ? eyeIco : eyeIcoDrk} />
        <Typography fontSize={16} fontWeight={tab === 1 ? 500 : 400}>
          Viewed Error
        </Typography>
        <Typography variant="body1" fontWeight={700} fontSize={20}>
          {view_count}
        </Typography>
      </Box>
    </Grid>
    <Grid item sm={12} md={12}>
      {tab === 0 ? (
        <Box component="div" className="card scroll" marginTop={2}>
         {data?.newLogs?.length > 0 ?  <ul className="error_list">
            {data?.newLogs?.map((error, index) => (
            <li key={index} onClick={() => handleOpen({id:error?.index,message:error?.log})}>
              <span>
                <img src={err_list_ico} alt="err" />
              </span>
              <span>App Error :</span>{error?.log}
            </li>))
            }
            
          </ul>:<div style={{padding:"2%"}}>No Data found</div>}
        </Box>
      ) : (
        <Box component="div" className="card scroll" marginTop={2}>
         {data?.readLogs?.length > 0 ? <ul className="error_list_viewed">
                {data?.readLogs?.map((error, index) => (
            <li key={index} onClick={() => handleOpen({id:error?.index,message:error?.log,type:'viewed'})}>
              <span>
              <img src={err_list_ico_viewed} alt="err" />
              </span>
              <span>App Error :</span>{error?.log}
            </li>))
            }
           
          </ul>:<div style={{padding:"2%"}}>No Data found</div>}
        </Box>
      )}
    </Grid>
  </Grid>
  )
}

export default ErrorComponent